import { useSafeAreaInsets } from "@medbillai/ui";
import { ScreenView, type ScreenViewProps } from "../../components/ScreenView";
import { AccountsHomeContent } from "./accounts-home/AccountsHomeContent";
import { useAccountLinksData } from "./utils/AccountLinksDataProvider";
export type AccountsScreenProps = {
  screenViewProps?: Omit<ScreenViewProps, "children">;
};
export function AccountsScreen({
  screenViewProps
}: AccountsScreenProps) {
  const {
    top
  } = useSafeAreaInsets();
  const {
    isEmpty,
    refetch
  } = useAccountLinksData();
  return <ScreenView noPadding contentRefreshOffset={top} onRefresh={refetch} disableScroll={isEmpty} centerHorizontal widthLimit={false} backgroundColor={isEmpty ? undefined : "$surface1"} {...screenViewProps} data-sentry-element="ScreenView" data-sentry-component="AccountsScreen" data-sentry-source-file="accounts-home.tsx">
      <AccountsHomeContent data-sentry-element="AccountsHomeContent" data-sentry-source-file="accounts-home.tsx" />
    </ScreenView>;
}